import { createContext, getWithContextHOC } from '@futrli/shared-services';
import { ASSISTANT_TAB } from '../../../ui/assistant-side-panel/assistant-side-panel';

interface SidePanelProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export interface SidePanelContextProps
  extends Omit<SidePanelProps, 'onOpen' | 'changeDateSelected' | 'changeAccountSelected'> {
  accountSwitchId?: string;
  accountId: string;
}

export interface ISidePanelContext {
  openSidePanel: (sidePanelProps?: SidePanelContextProps, activeTab?: ASSISTANT_TAB) => void;
  closeSidePanel: () => void;
}

export type SidePanelContextKeys = keyof ISidePanelContext;

const DEFAULT_OPTIONS: SidePanelContextKeys[] = ['openSidePanel', 'closeSidePanel'];

/**
 * SidePanel context initilised to be shared.
 *
 * NOTE: The context is comprise of all properties we want to share between the parent
 * and lower level nodes and the nodes between them do not need to know about these properties.
 */
export const SidePanelContext = createContext<Partial<ISidePanelContext>>({});

/**
 * Injects the SidePanel context to the component passed as param.
 * @name withSidePanelContext
 * @function
 * @param {React.ComponentType<RC & CP>} Component - Component to wrap with the consumer.
 * @param {Array<keyof C>} options - Context props to inject into the component.
 * @template {RC} - React component props without context props.
 * @template {CP} - Context props of the component.
 *
 * @returns {React.ComponentType<RC>} - Wrapped component.
 */
export const withSidePanelContext = getWithContextHOC(SidePanelContext, DEFAULT_OPTIONS);
